import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from '@mui/material/CircularProgress';
import SaveIcon from '@mui/icons-material/Save';

import AddProductTypeForm from "./AddProductTypeForm";
import { addData, clearQueryResult, queryProductType } from "../../actions/valueActions";


const AddProductData = ({ id, industry, type, productTypes, handleClose }) => {
    const formikRef = useRef(null);
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);

    const queryResult = useSelector(state => state.value.queryResult)

    const addProductFormAction = () => {
        return (
            <Box sx={{ position: 'relative', display: 'inline-block' }}>
                <Button
                    startIcon={<AutoFixHighIcon />}
                    type="submit"
                    disabled={loading}
                    sx={{ textTransform: 'none' }}
                >
                    Request
                </Button>
                {loading && (
                    <CircularProgress
                        size={24}
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            marginTop: '-12px',  // half of 24
                            marginLeft: '-12px', // half of 24
                            zIndex: 1,
                        }}
                    />
                )}
            </Box>
        )
    }

    const saveProductFormAction = () => {
        return (
            <React.Fragment>
                <Button
                    startIcon={<SaveIcon />}
                    type="submit"
                    sx={{ textTransform: 'none' }}
                >
                    Save
                </Button>
                <Button
                    startIcon={<AutoFixHighIcon />}
                    onClick={() => dispatch(clearQueryResult())}
                    sx={{ textTransform: 'none' }}
                >
                    Rerun Request
                </Button>
            </React.Fragment>
        )
    }

    const onSubmitProductType = async (values, { setSubmitting }) => {
        values.industry = industry

        setLoading(true)
        let success = false

        const result = await dispatch(queryProductType(id, values, { setSubmitting }))

        success = result?.success;
        setLoading(false)

        if (formikRef.current && !success) {
            formikRef.current.resetForm();
        }
    }

    const onSubmitSaveProductType = (values) => {
        let annualRevenue = values.annual_revenue
        annualRevenue.lower = annualRevenue.lower.toString().replace(/,/g, '');
        annualRevenue.higher = annualRevenue.higher.toString().replace(/,/g, '');

        let developmentCosts = values.development_costs
        developmentCosts.lower = developmentCosts.lower.toString().replace(/,/g, '');
        developmentCosts.higher = developmentCosts.higher.toString().replace(/,/g, '');

        values.annual_revenue = annualRevenue;
        values.development_costs = developmentCosts;

        dispatch(addData(id, type, 'product_type', values))

        handleClose()
    }

    function renderAddProductType() {
        // dispatch(clearQueryResult())

        return (
            <AddProductTypeForm
                productTypes={productTypes}
                queryResult={queryResult}
                formActions={addProductFormAction}
                formResultActions={saveProductFormAction}
                onSubmit={(values, { setSubmitting }) => onSubmitProductType(values, { setSubmitting })}
                onSubmitResult={onSubmitSaveProductType}
                ref={formikRef}
            />
        )
    }

    return (
        <Box>
            {renderAddProductType()}
        </Box>
    )
}

export default AddProductData